module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-agenda-item",
    class: 'm-agenda-item-theme-' + _vm.index
  }, [_c('div', {
    staticClass: "item-wrap",
    class: {
      'one-width': _vm.data.speaker.length == 1 || _vm.data.speaker.length == 0, 'double-width': _vm.data.speaker.length == 2, 'triple-width': _vm.data.speaker.length >= 3
    }
  }, [_c('div', {
    staticClass: "agenda-title"
  }, [_c('span', {
    staticClass: "t-name"
  }, [_vm._v(_vm._s(_vm.data.time))])]), _vm._v(" "), _c('div', {
    staticClass: "a-content"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.data.subject)
    }
  }), _vm._v(" "), _c('ul', _vm._l((_vm.data.speaker), function(item) {
    return _c('li', [(item.name != ' ' && item.name != '  ' && item.name != '   ') ? _c('div', {
      staticClass: "name-title"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "position"
    }, [_vm._v(_vm._s(item.position))])]) : _vm._e()])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "divider-line"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-82522778"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileAgendaItem.vue
// module id = 56
// module chunks = 0